/*Copyright © 2020 Rishabh Rao.
All Rights Reserved.*/

import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAdH2XL_MkNzAWBKITgyyaUlVM0NbnY_OM",
  authDomain: "openmessenger-reactjs.firebaseapp.com",
  databaseURL: "https://openmessenger-reactjs.firebaseio.com",
  projectId: "openmessenger-reactjs",
  storageBucket: "openmessenger-reactjs.appspot.com",
  messagingSenderId: "269213626262",
  appId: "1:269213626262:web:26413223f33bb1b02a77b7",
  measurementId: "G-T4B6YBFTM0",
});

const db = firebaseApp.firestore();

export default db;

const auth = firebase.auth();

var provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
